import axios from 'axios'
import history from '../history'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

export async function getAddress(dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.get('/location/getaddress',
        {
            headers: {
                HEADERS,
                'Authorization': AuthToken
            }
        }).then(response => {
            successGetAddress(response, dispatch);
        }).catch(erro => {
            console.log(erro)
            erroGetAddress(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successGetAddress(response, dispatch) {
    if (response.status === 200) {
        const endereco = {
            cep: response.data.cep,
            logradouro: response.data.name,
            bairro: response.data.neighborhood,
            localidade: response.data.city.name,
            uf: response.data.city.state.uf,
            ibge: response.data.city.code
        }
        dispatch({
            type: 'SET_ENDERECO',
            endereco: endereco
        })

        dispatch({
            type: 'SET_NUMERO',
            numero: response.data.number,
        })

        dispatch({
            type: 'SET_COMPLEMENTO',
            complemento: response.data.complement,
        })
    }
}

function erroGetAddress(erro, dispatch) {
    if (erro.status === 401) {
        history.push('/login')
    }
}